import React, { useEffect } from "react";
import { Flex, IconButton, Input, Select, Text } from "@chakra-ui/react";

import {
  BsChevronDoubleLeft,
  BsChevronDoubleRight,
  BsChevronLeft,
  BsChevronRight,
} from "react-icons/bs";

import { useDispatch, useSelector } from "react-redux";
import { getPagination } from "../../redux/actions/prospectActions";

const Footer = (tableInstance) => {
  const dispatch = useDispatch();

  const { isViewed, search } = useSelector((state) => state?.utils);

  const {
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    pageCount,
    pageIndex,
    pageOptions,
    setPageSize,
    pageSize,
  } = tableInstance;

  useEffect(() => {
    if (pageIndex > 0)
      dispatch(getPagination(pageIndex, pageSize, search, isViewed));
  }, [pageIndex, pageSize, isViewed, search]);

  return (
    <>
      <Flex alignItems="center" mt="2" mb="5" justifyContent="space-between">
        <Flex alignItems="center">
          <IconButton
            borderRadius="full"
            aria-label="Search database"
            mr="1"
            size="sm"
            icon={<BsChevronDoubleLeft size={12} />}
            onClick={() => gotoPage(1)}
            isDisabled={pageIndex <= 1 ? true : false}
          />
          <IconButton
            borderRadius="full"
            aria-label="Search database"
            mr="2"
            size="sm"
            icon={<BsChevronLeft size={12} />}
            onClick={() => {
              previousPage();
            }}
            isDisabled={pageIndex <= 1 ? true : false}
          />
          <Text fontSize="md" mr="1">
            {`${pageIndex} - ${pageOptions.length}`}
          </Text>
          <IconButton
            borderRadius="full"
            aria-label="Search database"
            mr="1"
            size="sm"
            icon={<BsChevronRight size={12} />}
            onClick={() => {
              nextPage();
            }}
            isDisabled={pageIndex == pageCount ? true : false}
          />
          <IconButton
            borderRadius="full"
            aria-label="Search database"
            size="sm"
            icon={<BsChevronDoubleRight size={12} />}
            onClick={() => {
              gotoPage(pageCount);
            }}
            isDisabled={pageIndex == pageCount ? true : false}
          />
        </Flex>

        <Input
          type="number"
          maxlength={pageCount}
          placeholder="Go To Page"
          w={"10%"}
          size="sm"
          min="0"
          defaultValue={1}
          pattern="[0-9]+"
          onChange={(e) => {
            gotoPage(Number(e.target.value));
          }}
        />

        <Select
          width={"15%"}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[50, 100, 300, 500, 100].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </Select>
      </Flex>
    </>
  );
};

export default Footer;
